var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgTick = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M19.3891 3.41011C19.9359 3.95693 19.9359 4.84495 19.3891 5.39176L8.19036 16.5905C7.64355 17.1373 6.75552 17.1373 6.20871 16.5905L0.609331 10.9911C0.0625145 10.4443 0.0625145 9.5563 0.609331 9.00949C1.15615 8.46267 2.04417 8.46267 2.59098 9.00949L7.20172 13.6158L17.4118 3.41011C17.9586 2.8633 18.8467 2.8633 19.3935 3.41011H19.3891Z",
  fill: "#E36D32"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgTick);
export { ForwardRef as ReactComponent };